import {
  CHAT_ACTION_STARTS,
  CHAT_ACTION_ERRORS,
  GET_ALL_CHATS,
  GET_CHAT_BY_ID,
  GET_USER_CHATS,
  CREATE_CHAT,
  UPDATE_CHAT,
  DELETE_CHAT,
} from './actions';

const initialState = {
  chats: [],
  userChats: [],
  currentChat: null,
  loading: false,
  error: null,
};

const chatReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CHAT_ACTION_STARTS:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CHAT_ACTION_ERRORS:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_ALL_CHATS:
      return {
        ...state,
        loading: false,
        chats: action.payload,
        error: null,
      };
    case GET_CHAT_BY_ID:
      return {
        ...state,
        loading: false,
        currentChat: action.payload,
        error: null,
      };
    case GET_USER_CHATS:
      return {
        ...state,
        loading: false,
        userChats: action.payload,
        error: null,
      };
    case CREATE_CHAT:
      return {
        ...state,
        loading: false,
        chats: [action.payload, ...state.chats],
        error: null,
      };
    case UPDATE_CHAT:
      return {
        ...state,
        loading: false,
        chats: state.chats.map((chat: any) =>
          chat.id === action.payload.id ? action.payload : chat
        ),
        currentChat: action.payload,
        error: null,
      };
    case DELETE_CHAT:
      return {
        ...state,
        loading: false,
        chats: state.chats.filter((chat: any) => chat.id !== action.payload),
        error: null,
      };
    default:
      return state;
  }
};

export default chatReducer;
